import React from 'react';
import {
    Box,
    List,
    ListItem,
    ListItemText,
    Divider,
    ListItemButton,
    ListSubheader,
} from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

const SettingItem = ({ setting, onClick }) => (
    <ListItem
        sx={{ cursor: 'pointer', paddingLeft: '30px', paddingRight: '40px', backgroundColor: 'transparent' }}
        disablePadding
    >
        <ListItemButton onClick={onClick}>
            <ListItemText primary={setting.label} sx={{ fontWeight: 'bold' }} secondary={setting.currentValue} />
            <ArrowForwardIos fontSize="small" />
        </ListItemButton>
    </ListItem>
    
);

const SettingsList = ({setShowList, redirectToHome, settingsData, setSettingSelected}) => {

    const handleSettingChange = (setting) => {
        setSettingSelected(setting);
        setShowList(false);
    };
    
    return (
        <Box sx={{ marginTop: '30px' }}>
            <div className="title-container">Settings</div>
            <Box className="settings-box" sx={{ border: '1px solid', borderColor: 'grey.300', borderRadius: 1, backgroundColor: 'white' }}>
                <div className="cursor-pointer" onClick={redirectToHome}>
                    <ArrowBackIos fontSize="small" />
                    <span>Home</span>
                </div>
                <List>
                    {settingsData.map((category, categoryIndex) => (
                        <React.Fragment key={categoryIndex}>
                            <Divider sx={{ marginBottom: '10px', width: '96%', margin: 'auto' }} />
                            <List subheader={<ListSubheader sx={{ fontSize: '20px', fontWeight: 400, color: 'rgb(66, 85, 94)' }}>{category.category + ' Configuration'}</ListSubheader>}>
                                {category.data.map((setting, settingIndex) => (
                                    <SettingItem key={`${categoryIndex}-${settingIndex}`} setting={setting} onClick={() => handleSettingChange(setting)} />
                                ))}
                            </List>
                        </React.Fragment>
                    ))}
                </List>
            </Box>
        </Box>
    );
}

export default SettingsList;
